import { render, staticRenderFns } from "./trailerslist.vue?vue&type=template&id=5842f890&scoped=true"
import script from "./trailerslist.js?vue&type=script&lang=js&external"
export * from "./trailerslist.js?vue&type=script&lang=js&external"
import style0 from "./trailerslist.vue?vue&type=style&index=0&id=5842f890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842f890",
  null
  
)

export default component.exports